import { calcTime, formatDistance } from '../../utils/utils.';
import { T } from '../../i18n';
import { AccessTime, Check, DirectionsBike, Favorite, FavoriteBorder, LocationOn } from '@mui/icons-material';
import { CalendarIcon } from '@mui/x-date-pickers';
import { Link } from 'react-router';
import { useContext, useState } from 'react';
import { State, StateContext } from '../../state';
import { Button } from '@mui/material';
import { FlexDivider } from '../../widgets/utils';

export const TourCard = ({tour, fake, onTourClick, horizontal, smallHorizontal, selected }: any) => {

    const { savePreferite, preferiteList } = useContext(StateContext) as State;
    const [imgLoaded, setImgLoaded] = useState(false);

    if (fake) {
      return (
        <div className='card tour fake'>
        </div>
      )
    }

    const isPreferite = preferiteList.find((t: any) => t.id === tour.id)
  
    const difficulty = tour.routes[0].difficulty
    const distance = tour.routes.map((r:any) => r.infos.distance).reduce((a:any, b:any) => a + b, 0)
    let tourClass = (selected ? 'card-selected relative' : '') + " " +  (horizontal ? 'card tour tour-horizontal': 'card tour')
    if(smallHorizontal) {
      tourClass += ' small-tour-horizontal'
    }

    const Wrapper = ({children, onTourClick}:any) => {
      if(!onTourClick) {
        return (
          <Link className="no-link" to={`../tour/${tour.id}`} target="_blank" rel="noopener noreferrer" >
            {children}
          </Link>
        )
      }
      return <span onClick={onTourClick}>{children}</span>
    }

    const mobile = window.innerWidth <= 600

    return (
      <Wrapper onTourClick={onTourClick}>
        <div className={tourClass} >
          {selected && 
          <div className='card-selected-badge'>
            <Check/>
          </div>
          }
          <div className={"card-img1" + (imgLoaded ? "" : " card-img1-loading")}>
            <img
              src={tour.image}
              alt=""
              className={"main-img" + (imgLoaded ? " main-img-loaded" : "")}
              loading="lazy"
              onLoad={() => setImgLoaded(true)}
            />
            <div className="badge badge-float badge-black">{difficulty}</div>
            <div className="badge badge-float preferiti-icon" onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              savePreferite(tour)
            }}>
              {isPreferite ? 
                <Favorite style={{fill: '#E91E63'}} />:
                <FavoriteBorder/>
              }
            </div>
          </div>
          <div className='card-container'>
            <h5 className='card-location'><LocationOn sx={{width: 15, height: 15}}/>{tour.location}</h5>
            <h3 className={selected ? 'ellipsis' : ''}>{tour.title}</h3>
            <FlexDivider/>
            <div className="tour-card-price">
              <div className="tour-card-price-info">
                <div className="row gap-10">{tour.routes.length > 1 ? <CalendarIcon/>: <AccessTime/>}{tour.routes.length > 1 ? `${tour.routes.length} ${T('Days')}`: calcTime(distance)}</div>
                <div className="row gap-10"><DirectionsBike/> {formatDistance(distance)}</div>
              </div>
              <b style={{ fontSize: 24 }}>{tour.price}€</b>
            </div>
            {selected && mobile && 
              <div style={{height: 37}}/>}
            {selected && 
            <span className='button-scopri'>
              <br/>
                <Link className="no-link click" to={`../tour/${tour.id}`} target="_blank" rel="noopener noreferrer">
                <Button 
                  className="fullwidth" sx={{ borderRadius: '16px'}} variant="contained"> {T('discover_and_reserve')}</Button>
                </Link>
              </span>
            }
          </div>
        </div>
      </Wrapper>
    )
  }
  